import API from "./api";

const FileUploadService = {
  uploadImage: async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await API.post("/files/upload/image", formData);
    return response.data.donnees ?? response.data;
  },

  uploadVideo: async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await API.post("/files/upload/video", formData);
    return response.data.donnees ?? response.data;
  },

  uploadDocument: async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await API.post("/files/upload/document", formData);
    return response.data.donnees ?? response.data;
  },

  delete: async (key: string) => {
    const response = await API.delete("/files", {
      params: { key },
    });

    return response.data.donnees ?? response.data;
  },
};

export default FileUploadService;
